import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={28}
    height={29}
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.6 26.413c-6.863 0-12.443-5.466-12.443-12.191s5.58-12.19 12.444-12.19c6.863 0 12.443 5.465 12.443 12.19s-5.58 12.19-12.443 12.19m0-22.68c-5.903 0-10.706 4.705-10.706 10.489s4.803 10.49 10.707 10.49c5.903 0 10.706-4.706 10.706-10.49s-4.803-10.49-10.706-10.49'
      fill='var(--color-primary)'
    />
    <path
      d='M12.246 18.566a.88.88 0 0 1-.613-.25l-3.276-3.21a.843.843 0 0 1 0-1.201.886.886 0 0 1 1.227 0l2.662 2.608 5.95-5.829a.886.886 0 0 1 1.227 0 .843.843 0 0 1 0 1.202l-6.563 6.43a.88.88 0 0 1-.614.25'
      fill='var(--color-primary)'
    />
  </svg>
);
export default SVGComponent;
